import { render } from "./Fancy-hero.vue?vue&type=template&id=a3f12f04"
import script from "./Fancy-hero.vue?vue&type=script&lang=js"
export * from "./Fancy-hero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__